
import { route } from "../../../../globals/constants";
import { NavLink } from "react-router-dom";
import { parseTitle } from "../../../../utils";

function Title2({
    options,
    data 
}) {

    const desc = parseTitle(options?.description3)

    return (
        <div className="section-full bg-gray p-t80  p-b50">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12">
                        {/* TITLE START*/}
                        <div className="section-head text-left">
                            <h2>{options?.title}</h2>
                            <div className="mt-separator-outer">
                                <div className="mt-separator site-bg-primary" />
                            </div>
                        </div>
                        {/* TITLE END*/}
                        <div className="section-content sx-why-choose">
                            <div className="mt-box">
                                <div className="mt-info bg-white text-left p-a20 m-b30">
                                    <h4>{options?.subtitle11}</h4>
                                    <p>{options?.description}</p>
                                    <NavLink to={route.pages.ABOUT} className="site-button-link site-text-primary font-weight-600">Read More</NavLink>
                                </div>
                            </div>
                            <div className="mt-box m-b30">
                                <div className="mt-info bg-white text-left p-a20">
                                     <h4>{options?.subtitle12}</h4>
                                    <p>{options?.description2}</p>
                                    <NavLink to={route.pages.ABOUT} className="site-button-link site-text-primary font-weight-600">Read More</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        {/* TITLE START*/}
                        <div className="section-head text-left">
                            <h2>{options?.title2}</h2>
                            <div className="mt-separator-outer">
                                <div className="mt-separator site-bg-primary" />
                            </div>
                        </div>
                        {/* TITLE END*/}
                        <div className="section-content  clearfix ">
                            <div className="p-b0">
                                <div className="mt-box">
                                    <h2 className="m-t0"><span className="site-text-primary">{`${desc.one} ${desc.two} `}</span>{desc.three}</h2>
                                </div>
                                <div className="our-exp">
                                    {
                                        data && data?.length > 0 && data.map((item,index) => {
                                            return (
                                                <div key={`item-${index}`}>
                                                    <span className="progressText text-black"><b>{item?.title}</b></span>
                                                    <div className="progress m-b30 m-t10">
                                                        <div className="progress-bar site-bg-primary progress-bar-striped progress-bar-animated text-black" role="progressbar" style={{ width: '85%' }} aria-valuenow={item?.description} aria-valuemin={0} aria-valuemax={100}>{`${item.description}%`}</div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Title2;
